export default {
	"joinOrderPage": {
		"addRoutetips": "Select the waybill to be added"
	},
	"zd": {
		"time": "time",
		"code": "code",
		"min": "min",
		"hour": "hour",
		"day": "day"
	},
	"orders": {
		"endPickerTime": "The actual completion time",
		"checkedPersonName": "Confirm order by",
		"freightFlag": "Is there a shipping fee",
		"viewbill": "View bill",
		"checkList": "check list",
		"addMark": "Supplementary traces",
		"manualAddMark": "Manual replenishment of shipping traces",
		"temperature": "temperature",
		"clickToSelectAddress": "Please click the icon to select the address",
		"manualEntry": "Manual entry",
		"accountsReceivable": "bills receivable",
		"rejected": "rejected",
		"submitted": "submitted",
		"tips1": "Please enter a shipping order or select a query time range",
		"tips2": "Are you sure you want to close the checked shipping order",
		"tips3": "Please select the vehicle for which traces need to be added",
		"tips4": "Please select a time",
		"tips5": "time must be greater than vehicle",
		"tips6": "start time",
		"tips7": "The time must be less than the vehicle",
		"tips8": "end time",
		"finalCost": "Estimated/final cost",
		"latestDeliveryDt": "Required/Actual Start Time",
		"latestReceivedDt": "Required/Actual End Time",
		"volume": "Actual Volume (Cubic Meter)",
		"weight": "Actual Weight (kg)",
		"packingQty": "Actual Package",
		"taskQty": "Number of task",
		"checkedPersonDt": "Review time"
	},
	"taskInfo": {
		"actualTemperatureRange": "Actual temperature control range",
		"actualPackingQty": "The actual number of outer packaging",
		"actualGoodsDescription": "Description of the delivered goods",
		"goodsHandoverInfo": "cargo delivery details",
		"record": "Record",
		"showOperationRecord": "show operation log",
		"showRecordInfo": "Display log information",
		"deliverGoodsRelevant": "PickUp related",
		"pickRelevant": "Delivery related",
		"receiptRelated": "Receipt related",
		"RelativeException": "exception correlation",
		"askInformation": "request information",
		"informationRecord": "record information",
		"fileManagement": "file management",
		"addFile": "Add attachments"
	},
	"tempMonitoring": {
		"noMonitoring": "No monitoring",
		"screen": "filter",
		"refresh": "refresh",
		"all": "all",
		"keyPoint": "focus",
		"grouping": "grouping",
		"groupingType": "group method",
		"single": "order",
		"stress": "focus",
		"arrived": "Arrived",
		"stopMonitoring": "stop monitoring",
		"monitoring": "monitor",
		"distance": "distance",
		"noMonitoringInfo": "No monitoring information",
		"thisOvertemp": "over temperature",
		"remainingMileage": "remaining mileage",
		"driverTelephone": "driver phone",
		"noticeTips": "Whether to notify the driver by SMS",
		"messageSentSuccessfully": "message sent successfully",
		"setSuccessfully": "Set up successfully!"
	},
	"transportContentInfo": {
		"packingDetail": "Goods packing details",
		"logInfo": "Operational information",
		"pickupOperateDt": "Pickup confirmation time",
		"deliveryOperateDt": "Delivery confirmation time",
		"routeCompletionMode": "how to finish",
		"electronicReceiptCheckedDt": "Electronic confirmation time",
		"electronicReceiptCheckedPersonName": "Electronic confirmer"
	},
	"transportInfo": {
		"save": "confirm save",
		"goodsValue": "declared value",
		"dataCorrect": "data correction"
	},
	"vehicleList": {
		"workAmount": "workload",
		"serviceItemsInfo": "Service item information",
		"orderServiceItemsInfo": "Order Service item information",
		"workServiceItemsInfo": "Work Service item information"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/track/track.js